import { render, staticRenderFns } from "./PageLinkAreas.vue?vue&type=template&id=e3fb48c0&scoped=true"
import script from "./PageLinkAreas.vue?vue&type=script&lang=js"
export * from "./PageLinkAreas.vue?vue&type=script&lang=js"
import style0 from "./PageLinkAreas.vue?vue&type=style&index=0&id=e3fb48c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fb48c0",
  null
  
)

export default component.exports